import React, { useContext, useEffect } from "react";
import { useParams } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import Grid from "@material-ui/core/Grid";
import Tooltip from "@material-ui/core/Tooltip";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import * as Dati from "src/Dati";
import * as DatiFide from "src/DatiFide";
import { Trad } from "src/components";
import useReducerOnChange from "src/hooks/ReducerOnChange";
import ChiamaWeb, {CChiamaWebParametri} from "src/ChiamaWeb";
import { _Autocomplete, _DateField, _NumberField, _Select } from "../../form";
import { _Button, _ButtonAPI, _CoobligatedList } from "../../components";
import { IRouteParam } from "../../pages/BondsCoobligated";
import { AlertDialogContext } from "../../providers/AlertDialogProvider";
import PrintIcon from "@material-ui/icons/Print";
import {onPrint, onPrintCoobligated} from "../Bond/helpers";

const useStyles = makeStyles({
    addIcon: {
        float: "right"
    }
});

interface ICoobligatedListFormProps {
    ID_FideAffidamento: string;
    ID_Polizza: string;
}

export const _CoobligatedListForm: React.FC<ICoobligatedListFormProps> = ({ ID_FideAffidamento, ID_Polizza }) => {
    const classes = useStyles();

    const { ShowDialog } = useContext(AlertDialogContext);
    const [Data, setData] = useReducerOnChange<DatiFide.CRisAPILista_FideCoobbligato>(new DatiFide.CRisAPILista_FideCoobbligato());

    useEffect(() => {
        GetData();
    }, [useParams<IRouteParam>().ID_FideAffidamento, useParams<IRouteParam>().ID_Polizza]);

    const OnApiError = (error: Error) => {
        ShowDialog("ERRORE", error.message, "error");
    };

    const GetData = (): void => {
        const Param: CChiamaWebParametri = {
            URL: `/api/fidecoobbligato/ricerca?ID_FideAffidamento=${ID_FideAffidamento}&ID_Polizza=${ID_Polizza}`,
            OnRis: OnGetData,
            OnErrore: (sender: ChiamaWeb, error: Error) => OnApiError(error)
        };
        new ChiamaWeb().Chiama(Param);
    };

    const OnGetData = (sender: ChiamaWeb, data: DatiFide.CRisAPILista_FideCoobbligato) => {
        setData({ Type: "Set", Value: data });
    };

    const OnAddCoobliged = () => {
        const items = [...Data.RisAPI.Dati];
        const newItem = new DatiFide.CDatiFideCoobbligato();

        for (let i in items) {
            if (items[i].ID_Anag == 0) {
                return;
            }
        }

        newItem.ID_FideAffidamento = Number(ID_FideAffidamento) || undefined;
        newItem.ID_Polizza = Number(ID_Polizza) || undefined;
        items.push(newItem);
        setData({ Type: "OnChangeFromValue", Name: "RisAPI.Dati", Value: items });
    };

    const GetFormData = (): Dati.CIngrAPILista<DatiFide.CDatiFideCoobbligato> => {
        const data = new Dati.CIngrAPILista<DatiFide.CDatiFideCoobbligato>();

        if (Data.RisAPI.Dati.length > 0) {
            data.Dati = Data.RisAPI.Dati;
        } else {
            const newItem = new DatiFide.CDatiFideCoobbligato();
            newItem.ID_FideAffidamento = Number(ID_FideAffidamento) || undefined;
            newItem.ID_Polizza = Number(ID_Polizza) || undefined;
            newItem.Quota = -1;
            data.Dati = [];
            data.Dati.push(newItem);
        }
        return data;
    };

    const OnClickSave = () => {
        ShowDialog("Coobbligati", Trad.Trad("Operazione avvenuta correttamente"), "success");
    };

    return (
        <Grid container spacing={4}>
            <Grid item xs={12}>
                <Tooltip title={Trad.Trad("Nuovo")} className={classes.addIcon}>
                    <IconButton aria-label="add" size="small" onClick={OnAddCoobliged}>
                        <AddCircleIcon color="secondary" fontSize="large" />
                    </IconButton>
                </Tooltip>
                <_CoobligatedList Data={Data} OnChange={(e, val) => setData({ Type: "OnChangeFromHybrid", NameEvent: val != null && val != undefined ? e : Object.assign({}, e), Value: val })} />
            </Grid>
            <Grid item container spacing={3} justify="flex-end">
                <Grid item>
                    <_Button Testo={Trad.Trad("Stampa")} Icona={<PrintIcon/>}
                             OnClick={() => onPrintCoobligated(ID_Polizza, Data.RisAPI.Dati, Data.Extra.CoAssicurazioneJSON)} Default={false} WithWrapper={false}/>
                </Grid>
                <Grid item>
                    <_Button Testo={Trad.Trad("Stampa Word")} Icona={<PrintIcon/>}
                             OnClick={() => onPrintCoobligated(ID_Polizza, Data.RisAPI.Dati, Data.Extra.CoAssicurazioneJSON, true)} Default={false} WithWrapper={false}/>
                </Grid>
                <Grid item>
                    <_ButtonAPI Default Attivo Testo={Trad.Trad("Salva")} URL="/api/fidecoobbligato/" OnInvio={GetFormData} OnClick={OnClickSave} OnErrore={OnApiError} />
                </Grid>
                <Grid item>
                    <_Button Default={false} WithWrapper={false} Testo={Trad.Trad("Annulla")} OnClick={GetData} />
                </Grid>
            </Grid>
        </Grid>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/components/BondsCoobligated/CoobligatedListForm.tsx